import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ContextService } from 'app/core/services/context.service';
import { FeatureFlags } from 'app/shared/services';
import { MenuIdentifiers } from 'core/services/navigation.service';
import { Role } from 'shared/constants/role';
import { NotificationService } from 'shared/services/notification.service';
import { BaseNavigationGuard } from './base-navigation.guard';

@Injectable({ providedIn: 'root' })
export class DriverPerformanceGuard extends BaseNavigationGuard implements CanActivate {
  constructor(
    private notificationService: NotificationService,
    private translation: TranslateService,
    private contextService: ContextService
  ) {
    super();
  }

  public canActivate(): boolean {
    if (!this.contextService.isFeatureFlagEnabled(FeatureFlags.DriverPerformance)) {
      this.router.navigate(['/home']);
      return false;
    }

    const canAccess = this.canAccessRoute(MenuIdentifiers.YARD_OPERATIONS_DRIVER_PERFORMANCE, [
      Role.DriverSupervisor,
    ]);
    if (!canAccess) {
      this.notificationService.error(this.translation.instant('httpErrorCodes.unauthorized'));
    }
    return canAccess;
  }
}